import { create } from 'zustand'

// Interface
interface ResumeStore {
  exist: boolean
  setExist: (exist: boolean) => void
}

export const useResume = create<ResumeStore>((set) => ({
  exist: false,
  setExist: (exist: boolean) => {
    set({ exist })
  },
}))
